<script>
import { mapActions } from "vuex";
import bankMixin from "@/mixins/bankMixin";
import ErrorInput from "@/components/_Shared/ErrorInput";

export default {
  mixins: [bankMixin],
  components: {
    ErrorInput
  },

  props: {
    bankAccount: {
      required: true,
      type: Object
    },
    paymentGatewayAccountId: {
      require: true,
      type: String
    }
  },

  data() {
    return {
      banks: null,
      account_types: null,
      bankPreloader: false
    };
  },

  methods: {
    ...mapActions("bankAccounts", ["createBankAccount", "updateBankAccount"]),

    async sendBankAccount() {
      this.bankPreloader = true;

      try {
        const valid = await this.$validator.validateAll("bankAccount");

        if (!valid || !this.bankAccount.bank_number) {
          return;
        }

        let data = {
          bank_account: this.bankAccount,
          payment_gateway_account_id: this.paymentGatewayAccountId
        };

        if (this.bankAccount.id) {
          data = { ...data, bank_account_id: this.bankAccount.id };
          this.bankAccount = await this.updateBankAccount(data);

          if (this.bankAccount != {}) {
            this.$toast.success("Conta bancária atualizada com sucesso!");
          } else {
            this.$toast.error("Não foi possível atualizar a conta bancária!");
          }
        } else {
          this.bankAccount = await this.createBankAccount(data);

          if (this.bankAccount.id == null) {
            this.$toast.error("Não foi possível cadastrar a conta bancária!");
          } else {
            this.$toast.success("Conta bancária cadastrada com sucesso!");
          }
        }
      } catch (e) {
        this.$toast.error(e);
      }

      this.bankPreloader = false;
    }
  }
};
</script>

<template>
  <div>
    <div class="title-form mt-30">DADOS BANCÁRIOS</div>

    <v-layout align-center justify-space-between row fill-height wrap>
      <v-flex md6 xs12>
        <v-selectpage
          name="account_type"
          v-validate="'required'"
          data-vv-as="tipo"
          data-vv-scope="bankAccount"
          v-model="bankAccount.account_type"
          :data="account_types"
          title="tipo"
          placeholder="tipo"
          key-field="value"
          show-field="name"
        ></v-selectpage>

        <ErrorInput
          v-if="errors.has('bankAccount.account_type')"
          :message="errors.first('account_type')"
        />
      </v-flex>

      <v-flex md6 xs12>
        <v-selectpage
          name="bank_number"
          v-validate="'required'"
          data-vv-as="banco"
          data-vv-scope="bankAccount"
          v-model="bankAccount.bank_number"
          :data="banks"
          title="Banco"
          placeholder="banco"
          key-field="code"
          show-field="name"
        ></v-selectpage>

        <ErrorInput
          v-if="errors.has('bankAccount.bank_number')"
          :message="errors.first('bank_number')"
        />
      </v-flex>
    </v-layout>

    <v-layout align-center justify-space-between row fill-height wrap>
      <v-flex px-1 md4 xs8>
        <v-text-field
          name="agency"
          label="agência"
          data-vv-scope="bankAccount"
          v-model="bankAccount.agency_number"
          :error="errors.has('bankAccount.agency')"
          :error-messages="errors.first('agency')"
          v-validate="'required|numeric'"
        />
      </v-flex>

      <v-flex px-1 md2 xs4>
        <v-text-field
          name="agency_check_number"
          label="dígito da agência"
          data-vv-scope="bankAccount"
          v-model="bankAccount.agency_check_number"
          :error="errors.has('bankAccount.agency_check_number')"
          :error-messages="errors.first('agency_check_number')"
          v-validate="'numeric'"
        />
      </v-flex>

      <v-flex px-1 md4 xs8>
        <v-text-field
          name="account_number"
          label="conta"
          data-vv-scope="bankAccount"
          v-model="bankAccount.account_number"
          :error="errors.has('bankAccount.account_number')"
          :error-messages="errors.first('account_number')"
          v-validate="'required|numeric'"
        />
      </v-flex>

      <v-flex px-1 md2 xs4>
        <v-text-field
          name="account_check_number"
          label="digito da conta"
          data-vv-scope="bankAccount"
          v-model="bankAccount.account_check_number"
          :error="errors.has('bankAccount.account_check_number')"
          :error-messages="errors.first('account_check_number')"
          v-validate="'required|numeric'"
        />
      </v-flex>
    </v-layout>

    <div class="group-button">
      <v-btn
        color="primary"
        small
        :loading="bankPreloader"
        @click="sendBankAccount"
      >
        <span>Atualizar dados bancários</span>
      </v-btn>
    </div>
  </div>
</template>

<style scoped>
.row {
  margin: 0;
}

.group-button {
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/FormData/BankAccountData.vue